import HStack from "shared/components/layout/stack/HStack";
import styled from "styled-components/macro";

export const CalendarWrapper = styled(HStack)`
    flex-wrap: wrap;
    row-gap: 16px;
    column-gap: 8px;
    width: 102%;
`;
